<template><div><h1 id="anlass" tabindex="-1"><a class="header-anchor" href="#anlass"><span>Anlass</span></a></h1>
<p>Anlass — Einrichtung von Anlassspenden</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dient der Abwicklung von Anlassspenden. Bei einer Anlassspende werden z.B. an Geburtstagen, Hochzeiten, Beerdigungen etc. Spendengelder gesammelt. Die Teilnehmer des Anlasses erhalten einen Einzahlungsschein und zahlen selber ein. Die einzelnene Zahlungen werden dann zu diesem Anlass erfasst bzw. zugeordnet. Eine Verdankung kann wahlweise an die Kontaktperson und/oder die einzelnen Spender versendet werden.</p>
<p>Pfad: <code v-pre>Personen → Anlassspenden → Anlassspenden</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Ereignis</dt>
<dd>Das <a class="link" href="ft.refdata.ereigkopf.html" title="Ereignisse">Ereignis</a> muss vorgängig in der Ereignistabelle erfasst sein. In der Regel werden die einzelnen Anlässe als Ereignspositionen zu einem Standard-Anlassspendenereignis erfasst.</dd>
<dt>Position/Ereignis-Pos.</dt>
<dd>Die <a class="link" href="ft.refdata.ereigpos.html" title="Ereignispositionen">Ereignisposition</a> kann direkt in der Eingabemaske erfasst werden. Die Eingabe wird mit der Tabelle der Ereignispositionen verglichen. Wird keine übereinstimmende Ereignisposition gefunden, erfasst das System automatisch eine neue.</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung der Ereignisposition.</dd>
<dt>Anlassart</dt>
<dd>Lookup auf Tabelle Anlassarten</dd>
<dt>Betr.</dt>
<dd>Interne Person, die den Anlass betreut. Lookup auf Tabelle<a class="link" href="ft.refdata.benutzer.html" title="Benutzerstamm">Benutzer</a>.</dd>
<dt>Status</dt>
<dd>Status des Anlasses (aktiv/inaktiv).</dd>
<dt>V</dt>
<dd>Das Feld zeigt an ob der Anlass verarbeitet wurde oder noch nicht verarbeitet wurde. Leer = noch nicht verarbeitet, V = verarbeitet</dd>
</dl>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Der Anlass kann auch verarbeitet (V) sein, ohne einen Verdankungslauf durchgeführt zu haben, z.B. wenn die Verdankungen manuell ausgeschlossen wurden.</p>
</div>
<dl>
<dt>Ansprechperson</dt>
<dd>Die Ansprechperson des Anlasses für organisatorische Fragen.</dd>
<dt>Beteiligte</dt>
<dd>Dokumentation von weiteren<a class="link" href="ft.refdata.beteiligte.html" title="Beteiligte">Beteiligten</a>.</dd>
<dt>Verdankungsart</dt>
<dd>In diesem Feld wird die Art der Verdankung festgelegt:<br>Anlass = Verdankung über Anlasspenden<br>Verdankungs-Steuertabelle = Standardverdankung über<a class="link" href="ft.refdata.vdanksteuer.html" title="Verdankungssteuertabelle">Verdankungs-Steuertabelle.</a>.</dd>
</dl>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Responses auf inaktive Anlässe durchlaufen unabhängig von der Verdankungsart immer die Verdankungs-Steuertabelle!</p>
</div>
<dl>
<dt>Verdanken an</dt>
<dd>Die Verdankung kann für die Ansprechperson oder die Spender erstellt werden. Bei der Verdankung an die Ansprechperson wird dort einfach der Totalbetrag der noch nicht verdankten Spenden in einer einzigen Verdankung angezeigt.</dd>
<dt>Verdanken ab</dt>
<dd>Erst ab diesem Datum werden die eingegangenen Spenden verdankt.</dd>
<dt>Dokumentensatz</dt>
<dd><a class="link" href="ft.refdata.do-doksatz.html" title="Dokumententensatz">Dokumentensatz</a> für die Verdankung, sofern über den Anlass verdankt wird.</dd>
<dt>Dokumentencode</dt>
<dd>Dokumentcode, der im Outputformat mitgeliefert wird, um unterschiedliche Briefvarianten für die einzelnen Anlassarten verwenden zu können.</dd>
<dt>Bemerkungen</dt>
<dd>Notizfeld für interne Bemerkungen.</dd>
<dt>Anzahl (Response)</dt>
<dd>Anzahl eingegangene Responses zum Anlass.</dd>
<dt>Wert (Wert)</dt>
<dd>Responsewert, Summe aller Responsebeträge zum Anlass.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/anlassspenden.html" title="2. Anlassspenden">Anlassspenden</RouteLink></p>
</div></template>


